import React, { useRef, useState, Fragment, useEffect } from "react";
import "../../App.css";
//import { Auth, API, Storage } from "aws-amplify";
import { signIn, signOut, resetPassword, confirmResetPassword, confirmSignIn } from 'aws-amplify/auth';
import { listUsuarios } from "../../graphql/queries";
import { Navbar, Col, Row, Button, Form, FormGroup, Label, Input, Alert } from "reactstrap";
import Slider from "../../components/slider";
import { Redirect } from "react-router-dom";
import { getUrl } from "@aws-amplify/storage";
import { generateClient } from "aws-amplify/api";
const API = generateClient();

window.$Activo = false;
window.$Almacen = false;
window.$Calidad = false;
window.$Cuarentena = false;
window.$AlmacenDInventario = false;
window.$MarcarEmbarcadoAlmacen = false;
window.$MarcarFueradePlanta = false;
window.$EmbarquesDInventario = false;
window.$MarcarEmbarcadoEmbarques = false;
window.$Incoming = false;
window.$Clientes = false;
window.$Cotizaciones = false;
window.$Planeacion = false;
window.$verPlaneacionBase = false;
window.$ResumenOperacionVer = false;
window.$ResumenOperacionEDefectos = false;
window.$ResumenOperacionEPLaboratorio = false;
window.$ResumenOperacionEAusentismoP = false;
window.$ResumenOperacionEDatosExtra = false;
window.$Productos = false;
window.$VerPrecioUnitario = false;
window.$Reciba = false;
window.$RecibaDescargar = false;
window.$IncomingDescarga = false;
window.$Usuarios = false;
window.$PProduccion = false;
window.$Produccion = false;
window.$Producciones = false;
window.$ProduccionInspeccion = false;
window.$ProduccionCalidad = false;
window.$ProduccionCargaManual = false;
window.$ProduccionRecuperacion = false;
window.$Tickets = false;
window.$TicketsUsuarios = false;
window.$TicketsSoporte = false;
window.$TicketsAuditor = false;
window.$Embarques = false;
window.$Facturacion = false;
window.$Compras = false;
window.$AgregarProvedores = false;
window.$AutorizarProvedores = false;
window.$LevantarRequisicion = false;
window.$AutorizarRequisicion = false;
window.$AutorizarCompra = false;
window.$Administrar = false;
window.$Metricas = false;
window.$Ubicacion = false;
window.$GestionarUbicacion = false;
window.$Notificaciones = false;
window.$ProduccionReporteSema = false;
window.$PProduccionAutNoFIFO1 = false;
window.$PProduccionAutNoFIFO2 = false;
window.$PlaneacionAutNoFIFO = false;
window.$verEmbarques = false;
window.$verPlanProduccion = false;
window.$verPlaneacion = false;
window.$Autorizaciones = false;
//window.$Datos=false;
window.$Imagen = "";

//Inicialización de variables forms
const initialFormState = {
  username: "",
  password: "",
  npassword: "",
  code: "",
  formType: "signIn",
};

//Función principal
function LogIn() {
  const [formState, updateFormState] = useState(initialFormState);
  const [isDisabled, setisDisabled] = useState(true);
  const [mensajeAlert, setMensajeAlert] = useState("");
  const [aVisible, setAVisible] = useState(false);
  const [color, setColor] = useState("warning");
  const [singInHiden, setSingInHiden] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [newPassHiden, setnewPassHiden] = useState(true);
  const [resetPassHiden, setResetPassHiden] = useState(true);
  const [resetPassHidenNC, setResetPassHidenNC] = useState(true);
  const [paginaInicial, setPaginaInicial] = useState("/home")
  const [textInstruc, setTextInstruc] = useState(
    "Ingresa tus datos para iniciar sesión."
  );
  const inputElement = useRef(null);
  //const [usuarios, setUsuarios] = useState({});
  const onDismiss = () => setAVisible(false);
  //const history = useHistory();
  const { formType } = formState;

  async function onLoad() {
    try {
      await signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  /*useEffect(() => {
    if (inputElement.current) {
      inputElement.current.focus();
    }
  }, []);*/

  //Logueo, cambiar contraseña temporal y cambiar contraseña
  function onChanges(e) {
    e.persist();
    updateFormState(() => ({ ...formState, [e.target.name]: e.target.value }));
  }

  //Logueo
  function logKeyPress(e) {
    if (formState.username === "" || formState.password === "") {
      setisDisabled(true);
    } else {
      setisDisabled(false);
    }
  }

  //Obtiene los datos de los usuarios
  async function fetchUsuarios() {
    try {
      var nextToken = null;
      var apiData = [];
      do {
        const apiOData = await API.graphql({
          query: listUsuarios,
          variables: {
            filter: { activo: { eq: true } },
            limit: 100000000,
            nextToken,
            authMode: "AMAZON_COGNITO_USER_POOLS",
          },
        });
        const odatos = await apiOData.data.listUsuarios.items;
        nextToken = await apiOData.data.listUsuarios.nextToken;
        apiData = await [...apiData, ...odatos];
      } while (nextToken != null);

      //const apiData = await API.graphql({ query: listUsuarios, variables: { limit: 100000000 } });
      const usuariosFromAPI = apiData.filter(
        (usuario) =>
          usuario.usuario.toUpperCase() === formState.username.toUpperCase()
      );
      await Promise.all(
        usuariosFromAPI.map(async (usuario) => {
          if (usuario.image) {
            const image = await getUrl({ key: usuario.image });
            usuario.imagename = usuario.image;
            usuario.image = image.url.toString();
            window.$Imagen = image.url.toString();
          }
          if (
            usuario.TicketsSoporte ||
            usuario.TicketsUsuarios ||
            usuario.TicketsAuditor
          )
            usuario.Tickets = true;
          else usuario.Tickets = false;

          if (
            usuario.PProduccion === true ||
            usuario.Produccion === true ||
            usuario.ProduccionInspeccion === true
          )
            usuario.Producciones = true;
          else usuario.Producciones = false;

          if (
            usuario.Cuarentena === true ||
            usuario.Incoming === true ||
            usuario.ProduccionCalidad ||
            usuario.ProduccionRecuperacion
          )
            usuario.Calidad = true;
          else usuario.Calidad = false;

          if (
            usuario.PProduccionAutNoFIFO1 === true ||
            usuario.PProduccionAutNoFIFO2 === true ||
            usuario.PlaneacionAutNoFIFO === true ||
            usuario.AutorizarCalidad === true ||
            usuario.AutorizarEmbarques === true ||
            usuario.AutorizarTodo === true
          )
            usuario.Autorizaciones = true;
          else usuario.Autorizaciones = false;

          window.$Activo = usuario.activo;
          window.$Almacen = usuario.Almacen;
          window.$Cuarentena = usuario.Cuarentena;
          window.$AlmacenDInventario = usuario.AlmacenDInventario;
          window.$MarcarEmbarcadoAlmacen = usuario.MarcarEmbarcadoAlmacen;
          window.$MarcarFueradePlanta = usuario.MarcarFueradePlanta;
          window.$EmbarquesDInventario = usuario.EmbarquesDInventario;
          window.$MarcarEmbarcadoEmbarques = usuario.MarcarEmbarcadoEmbarques;
          window.$Calidad = usuario.Calidad;
          window.$Incoming = usuario.Incoming;
          window.$Clientes = usuario.Clientes;
          window.$Cotizaciones = usuario.Cotizaciones;
          window.$Planeacion = usuario.Planeacion;
          window.$verPlaneacionBase = usuario.verPlaneacionBase;
          window.$ResumenOperacionVer = usuario.ResumenOperacionVer;
          window.$ResumenOperacionEDefectos = usuario.ResumenOperacionEDefectos;
          window.$ResumenOperacionEPLaboratorio = usuario.ResumenOperacionEPLaboratorio;
          window.$ResumenOperacionEAusentismoP = usuario.ResumenOperacionEAusentismoP;
          window.$ResumenOperacionEDatosExtra = usuario.ResumenOperacionEDatosExtra;
          window.$Productos = usuario.Productos;
          window.$VerPrecioUnitario = usuario.VerPrecioUnitario;
          window.$Reciba = usuario.Reciba;
          window.$RecibaDescargar = usuario.RecibaDescargar;
          window.$IncomingDescarga = usuario.IncomingDescarga;
          window.$Usuarios = usuario.Usuarios;
          window.$Producciones = usuario.Producciones;
          window.$PProduccion = usuario.PProduccion;
          window.$Embarques = usuario.Embarques;
          window.$Facturacion = usuario.Facturacion;
          window.$Compras = usuario.Compras;
          window.$AgregarProvedores = usuario.AgregarProvedores;
          window.$AutorizarProvedores = usuario.AutorizarProvedores;
          window.$LevantarRequisicion = usuario.LevantarRequisicion;
          window.$AutorizarRequisicion = usuario.AutorizarRequisicion;
          window.$AutorizarCompra = usuario.AutorizarCompra;
          window.$Administrar = usuario.Administrar;
          window.$Metricas = usuario.Metricas;
          window.$Ubicacion = usuario.Ubicacion;
          window.$GestionarUbicacion = usuario.GestionarUbicacion;
          window.$Notificaciones = usuario.Notificaciones;
          window.$Produccion = usuario.Produccion;
          window.$ProduccionInspeccion = usuario.ProduccionInspeccion;
          window.$ProduccionCargaManual = usuario.ProduccionCargaManual;
          window.$ProduccionCalidad = usuario.ProduccionCalidad;
          window.$ProduccionRecuperacion = usuario.ProduccionRecuperacion;
          window.$Tickets = usuario.Tickets;
          window.$TicketsUsuarios = usuario.TicketsUsuarios;
          window.$TicketsSoporte = usuario.TicketsSoporte;
          window.$TicketsAuditor = usuario.TicketsAuditor;
          window.$ProduccionReporteSema = usuario.ProduccionReporteSema;
          window.$PProduccionAutNoFIFO1 = usuario.PProduccionAutNoFIFO1;
          window.$PProduccionAutNoFIFO2 = usuario.PProduccionAutNoFIFO2;
          window.$PlaneacionAutNoFIFO = usuario.PlaneacionAutNoFIFO;
          window.$verEmbarques = usuario.verEmbarques;
          window.$verPlaneacion = usuario.verPlaneacion;
          window.$verPlanProduccion = usuario.verPlanProduccion;
          window.$Autorizaciones = usuario.Autorizaciones;
          window.$Datos = true;
          window.$refresh = true;
          setPaginaInicial(!usuario.PaginaInicial ? "/home" : usuario.PaginaInicial);
          return usuario;
        })
      );

      if (window.$Activo === false || !usuariosFromAPI.length) {
        if (formState.username === "gela") {
          window.$Datos = true;
          window.$Activo = true;
          window.$Usuarios = true;
          updateFormState(() => ({ ...formState, formType: "home" }));
        } else {
          setMensajeAlert(
            "El usuario no se encuentra activo; favor de comunicarse a sistemas"
          );
          setColor("warning");
          setCargando(false);
          setAVisible(true);
        }
      } else {
        updateFormState(() => ({ ...formState, formType: "home" }));
      }
    } catch (err) {
      setMensajeAlert(JSON.stringify(err));
      setColor("warning");
      setCargando(false);
      setAVisible(true);
    }
  }

  //Hace validaciones y logueo
  async function handleSignIn() {
    //Se cierra sesión en caso de que haya una sesión previa iniciada.
    await onLoad();
    var usuario = {};
    const { username, password } = formState;
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    if (username === "" || password === "") {
      setMensajeAlert("Faltan datos, favor de verificar");
      setColor("warning");
      setCargando(false);
      setAVisible(true);
    } else {
      try {

        const user = await signIn({ username, password })
        if (user.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
          setSingInHiden(true);
          setnewPassHiden(false);
          setTextInstruc("Cambiar contraseña");
          updateFormState(() => ({ ...formState, formType: "signIn" }));
          setMensajeAlert(
            "Se requiere cambiar contraseña. La contraseña debe cumplir con las siguientes políticas: debe tener una longitud mínima de 8, debe tener uno o más números, caracteres especiales, mayúsculas y minúsculas."
          );
          setColor("primary");
          setCargando(false);
          setAVisible(true);
        } else {
          setisDisabled(true);
          fetchUsuarios();
          //updateFormState(()=>({ ...formState, formType: "home"}));
        }


      } catch (err) {
        setMensajeAlert(err.message);
        if (err.message === "Incorrect username or password.")
          setMensajeAlert("Usuario o contraseña inválidos");
        if (err.message === "User does not exist.")
          setMensajeAlert("Usuario inexistente");
        if (
          err.message ===
          "Invalid verification code provided, please try again."
        )
          setMensajeAlert(
            "Código de verificación no válido, proporciona un código válido por favor."
          );
        if (
          err.message === "Attempt limit exceeded, please try after some time."
        )
          setMensajeAlert(
            "Se excedió el límite de intentos permitidos, inténtalo más tarde por favor."
          );
        if (err.message === "Network error")
          setMensajeAlert("Error de red, revisa tu conexción a internet.");
        setColor("warning");
        setCargando(false);
        setAVisible(true);
      }
    }
  }

  //Cambiar contraseña  temporal
  function cpKeyPress(e) {
    if (formState.npassword === "") {
      setisDisabled(true);
    } else {
      /*setMensajeAlert(formState.password + ' ' +  formState.username + ' ' + formState.npassword);            
     setAVisible(true);*/
      setisDisabled(false);
    }
  }

  async function newPassword() {
    const { username, password, npassword } = formState;
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    if (npassword === "") {
      setMensajeAlert("Faltan datos, favor de verificar");
      setColor("warning");
      setCargando(false);
      setAVisible(true);
    } else {
      try {
        const user = await signIn({ username, password });
        //.then((user) => {
        if (user.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
          /*Auth.completeNewPassword(
            user, // the Cognito User Object
            npassword, // the new password
            // OPTIONAL, the required attributes
            {}
          )*/
          await confirmSignIn({ challengeResponse: npassword })
            .then((user) => {
              setisDisabled(true);
              //updateFormState(()=>({ ...formState, formType: "home"}));
              fetchUsuarios();
            })
            .catch((e) => {
              setMensajeAlert(e.message);
              if (
                e.message ===
                "Password does not conform to policy: Password must have uppercase characters"
              )
                setMensajeAlert(
                  "La contraseña no cumple con la política: Debe tener mayúsculas."
                );
              if (
                e.message ===
                "Password does not conform to policy: Password must have numeric characters"
              )
                setMensajeAlert(
                  "La contraseña no cumple con la política: Debe tener números."
                );
              if (
                e.message ===
                "Password does not conform to policy: Password must have symbol characters"
              )
                setMensajeAlert(
                  "La contraseña no cumple con la política: Debe tener un carácter especial."
                );
              if (
                e.message ===
                "Password does not conform to policy: Password not long enough"
              )
                setMensajeAlert(
                  "La contraseña no cumple con la política: Debe tener una longitud mínima de 8."
                );
              if (
                e.message ===
                "Password does not conform to policy: Password must have lowercase characters"
              )
                setMensajeAlert(
                  "La contraseña no cumple con la política: Debe tener minúsculas."
                );
              if (
                e.message ===
                "Invalid verification code provided, please try again."
              )
                setMensajeAlert(
                  "Código de verificación no válido, proporciona un código válido por favor."
                );
              if (
                e.message ===
                "Attempt limit exceeded, please try after some time."
              )
                setMensajeAlert(
                  "Se excedió el límite de intentos permitidos, inténtalo más tarde por favor."
                );
              setColor("warning");
              setCargando(false);
              setAVisible(true);
            });
        } else {
          setisDisabled(true);
          //updateFormState(()=>({ ...formState, formType: "home"}));
          fetchUsuarios();
        }
      } catch (e) {
        setMensajeAlert(e.message + " -2 ");
        setColor("warning");
        setCargando(false);
        setAVisible(true);
      };
    }
  }

  //Cambiar contraseña
  //Valida que el campo de usuario no esté vacío
  function rpKeyPress(e) {
    if (formState.username === "") {
      setisDisabled(true);
    } else {
      setisDisabled(false);
    }
  }
  //Valida que los campos de código de verificación y nueva contraseña no estén vacíos
  function rpKeyPresscn(e) {
    if (formState.npassword === "" || formState.cverificacion === "") {
      setisDisabled(true);
    } else {
      setisDisabled(false);
    }
  }
  //Al dar click en el label de Olvidé mi contraseña, muestra el form para ingresar el usuario e iniciar el
  //proceso de cambio de contraseña
  function resetPasswordl() {
    setSingInHiden(true);
    setnewPassHiden(true);
    setResetPassHidenNC(true);
    setResetPassHiden(false);
    setTextInstruc("Cambiar contraseña");
    setMensajeAlert(
      "Ingresa tu usuario, se enviará un código de verificación a tu correo"
    );
    setColor("primary");
    setCargando(false);
    setAVisible(true);
    updateFormState(() => ({ ...formState, formType: "signIn" }));
  }
  //Envía el código de verificación al correo registrado del usuario ingresado
  async function fResetPassword() {
    const { username, password } = formState;
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    if (username === "") {
      setMensajeAlert("Faltan datos, favor de verificar");
      setColor("warning");
      setCargando(false);
      setAVisible(true);
    } else {//await Auth.forgotPassword(username)
      try {
        await resetPassword({ username });

        //console.log(data)
        setSingInHiden(true);
        setnewPassHiden(true);
        setResetPassHiden(true);
        setResetPassHidenNC(false);
        setTextInstruc("Cambiar contraseña");
        updateFormState(() => ({ ...formState, formType: "signIn" }));
        setMensajeAlert(
          "Ingresa el código de verificación y tu nueva contraseña. La contraseña debe cumplir con las siguientes políticas: debe tener una longitud mínima de 8, debe tener uno o más números, caracteres especiales, mayúsculas y minúsculas."
        );
        setColor("primary");
        setCargando(false);
        setAVisible(true);
      } catch (err) {
        //console.log(err)
        setMensajeAlert(err.message);
        if (
          err.message ===
          "User password cannot be reset in the current state."
        )
          setMensajeAlert(
            "El estado actual del usuario no permite un cambio de contraseña."
          );
        if (err.message === "Username/client id combination not found.")
          setMensajeAlert("Usuario inexistente.");
        setColor("warning");
        setCargando(false);
        setAVisible(true);
      };
    }
  }
  //Guarda la nueva contraseña y manda a la página principal de logueo
  async function resetPasswordNC() {
    const { username, password, npassword, code } = formState;
    setAVisible(false);
    setisDisabled(true);
    setCargando(true);
    if (username === "") {
      setMensajeAlert("Faltan datos, favor de verificar");
      setColor("warning");
      setCargando(false);
      setAVisible(true);
    } else {
      try {
        await confirmResetPassword({
          username: formState.username,
          confirmationCode: formState.code,
          newPassword: formState.npassword
        });

        //console.log(data)
        setSingInHiden(false);
        setnewPassHiden(true);
        setResetPassHiden(true);
        setResetPassHidenNC(true);
        setCargando(false);
        setTextInstruc("Ingresa tus datos para iniciar sesión.");
        updateFormState(() => ({ ...formState, formType: "signIn" }));
      } catch (err) {
        //console.log(err)
        setMensajeAlert(err.message);
        if (
          err.message ===
          "Password does not conform to policy: Password must have uppercase characters"
        )
          setMensajeAlert(
            "La contraseña no cumple con la política: Debe tener mayúsculas."
          );
        if (
          err.message ===
          "Password does not conform to policy: Password must have numeric characters"
        )
          setMensajeAlert(
            "La contraseña no cumple con la política: Debe tener números."
          );
        if (
          err.message ===
          "Password does not conform to policy: Password must have symbol characters"
        )
          setMensajeAlert(
            "La contraseña no cumple con la política: Debe tener un carácter especial."
          );
        if (
          err.message ===
          "Password does not conform to policy: Password not long enough"
        )
          setMensajeAlert(
            "La contraseña no cumple con la política: Debe tener una longitud mínima de 8."
          );
        if (
          err.message ===
          "Password does not conform to policy: Password must have lowercase characters"
        )
          setMensajeAlert(
            "La contraseña no cumple con la política: Debe tener minúsculas."
          );
        if (
          err.message ===
          "Invalid verification code provided, please try again."
        )
          setMensajeAlert(
            "Código de verificación no válido, proporciona un código válido por favor."
          );
        if (
          err.message ===
          "Attempt limit exceeded, please try after some time."
        )
          setMensajeAlert(
            "Se excedió el límite de intentos permitidos, inténtalo más tarde por favor."
          );
        setColor("warning");
        setCargando(false);
        setAVisible(true);
      };
    }
  }

  return (
    <div className="App 100">
      {formType === "signIn" && (
        <Fragment>
          <div className="h-100 " onLoad={onLoad}>
            <Row className="h-100 no-gutters">
              <Col lg="4" className="d-none d-lg-block">
                <div className="slider-light">
                  <Slider />
                </div>
              </Col>
              <Col
                lg="8"
                md="12"
                className="h-100 d-flex justify-content-center align-items-center bgbody"
              >
                <Col
                  lg="9"
                  md="10"
                  sm="12"
                  className="mx-auto app-login-box text-left "
                >
                  <div>
                    <Navbar className="navbarsh fcolord6e2e9 ">
                      <img
                        className="mar20 "
                        src="assets/img/Logo/logosf.png"
                      />
                      <h3 className="tbold">BTI CLOUD</h3>
                      <h3></h3>
                    </Navbar>
                  </div>
                  <div className="alvertc bvn">Bienvenido.</div>
                  <span>{textInstruc}</span>
                  <div className="hr" />
                  <Row className="divider" />
                  <div>
                    <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                      {mensajeAlert}
                    </Alert>
                    {cargando === true && (
                      <div>
                        <img
                          className="marl40 "
                          src="assets/img/preloader.gif"
                        />
                      </div>
                    )}
                    {singInHiden === false && (
                      <Form>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="Usuario">Usuario</Label>
                              <Input
                                name="username"
                                onChange={onChanges}
                                onKeyUp={logKeyPress}
                                autoFocus
                                placeholder="username"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="Contraseña">Contraseña</Label>
                              <Input
                                name="password"
                                type="password"
                                onChange={onChanges}
                                onKeyUp={logKeyPress}
                                placeholder="password"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <Label className="enlace" onClick={resetPasswordl}>
                              Olvidé mi contraseña
                            </Label>
                          </Col>
                        </Row>
                        <div className="d-flex align-items-center">
                          <div className="ml-auto">
                            <Button
                              onClick={handleSignIn}
                              href="#Login"
                              color="primary"
                              disabled={isDisabled}
                            >
                              Iniciar sesión
                            </Button>
                          </div>
                          {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}> Usuario: {JSON.stringify(window.$Imagen)}</div>
                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>  {JSON.stringify(usuarios)}</div>*/}
                        </div>
                      </Form>
                    )}
                    {newPassHiden === false && (
                      <Form>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="Contraseña">Nueva Contraseña</Label>
                              <Input
                                name="npassword"
                                type="password"
                                onChange={onChanges}
                                onKeyUp={cpKeyPress}
                                placeholder="password"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="d-flex align-items-center">
                          <div className="ml-auto">
                            <Button
                              onClick={newPassword}
                              color="warning"
                              disabled={isDisabled}
                            >
                              Cambiar contraseña
                            </Button>
                          </div>
                        </div>
                      </Form>
                    )}
                    {resetPassHiden === false && (
                      <Form>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="Usuario">Usuario</Label>
                              <Input
                                name="username"
                                onChange={onChanges}
                                onKeyUp={rpKeyPress}
                                placeholder="username"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="d-flex align-items-center">
                          <div className="ml-auto">
                            <Button
                              onClick={fResetPassword}
                              color="warning"
                              disabled={isDisabled}
                            >
                              Enviar código
                            </Button>
                          </div>
                        </div>
                      </Form>
                    )}
                    {resetPassHidenNC === false && (
                      <Form>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Código de verificación</Label>
                              <Input
                                name="code"
                                onChange={onChanges}
                                onKeyUp={rpKeyPresscn}
                                placeholder="Código"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="Contraseña">Nueva Contraseña</Label>
                              <Input
                                name="npassword"
                                type="password"
                                onChange={onChanges}
                                onKeyUp={rpKeyPresscn}
                                placeholder="password"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="d-flex align-items-center">
                          <div className="ml-auto">
                            <Button
                              onClick={resetPasswordNC}
                              color="warning"
                              disabled={isDisabled}
                            >
                              Cambiar contraseña
                            </Button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </div>
                </Col>
              </Col>
            </Row>
          </div>
        </Fragment>
      )}
      {formType === "home" && (
        <Fragment>
          <Redirect to={paginaInicial} />
        </Fragment>
      )}
    </div>
  );
}

export default LogIn;
